module.exports = __webpack_public_path__ + "static/img/home1.477aa474.png";